import { render, staticRenderFns } from "./appendProduct.vue?vue&type=template&id=3673a67d&scoped=true&"
import script from "./appendProduct.vue?vue&type=script&lang=js&"
export * from "./appendProduct.vue?vue&type=script&lang=js&"
import style0 from "./appendProduct.vue?vue&type=style&index=0&id=3673a67d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673a67d",
  null
  
)

export default component.exports